import React, { useEffect } from 'react';
import GetStartedForm from '../components/GetStartedForm'

const GetStarted = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <div>
            <GetStartedForm/>
        </div>
    );
};

export default GetStarted;